import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div<{ isOpen: boolean }>`
  background-color: #000;
  color: white;
  width: 250px;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform 0.3s ease;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    transform: translateX(${props => props.isOpen ? '0' : '-100%'});
    box-shadow: ${props => props.isOpen ? '2px 0 10px rgba(0,0,0,0.3)' : 'none'};
  }
`;

const Logo = styled.div`
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoImage = styled.img`
  max-width: 100%;
  height: 100%; 
  padding-top: 20px;
`;

const AdminText = styled.div`
  font-size: 16px;
  margin-top: -10px;
  text-align: center;
`;

const NavMenu = styled.nav`
  flex: 1;
  margin-top: 30px;
`;

const NavItem = styled(NavLink)<{ onClick?: () => void }>`
  padding: 15px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
  color: white;
  text-decoration: none;

  &:hover, &.active {
    background-color: rgba(255, 255, 255, 0.1);
  }

  span {
    margin-right: 15px;
    display: flex;
    align-items: center;
  }
`;

const IconImage = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const UserInfo = styled.div`
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.div`
  font-weight: bold;
`;

const UserEmail = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

const LogoutIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  
  img {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease-in-out;
  }
  
  &:hover img {
    transform: scale(1.2);
  }
`;

interface SidebarProps {
  onLogout: () => void;
  username?: string;
  isOpen?: boolean;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  onLogout, 
  username = 'User', 
  isOpen = true,
  onClose 
}) => {
  const handleNavClick = () => {
    // Close sidebar on mobile when navigation item is clicked
    if (onClose && window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <SidebarContainer isOpen={isOpen}>
      <Logo>
        <LogoImage src="/assets/carflow_logo.png" alt="CARFLOW" />
      </Logo>
      
      <NavMenu>
        <NavItem to="/cars" onClick={handleNavClick}>
          <span>
            <IconImage src="/assets/car_icon.png" alt="Car Icon" />
          </span> 
          Správa vozidiel
        </NavItem>
        <NavItem to="/settings" onClick={handleNavClick}>
          <span>
            <IconImage src="/assets/settings_icon.png" alt="Settings Icon" />
          </span> 
          Nastavenia
        </NavItem>
      </NavMenu>
      
      <UserInfo>
        <UserDetails>
          <UserName>{username}</UserName>
          <UserEmail>Prihlásený používateľ</UserEmail>
        </UserDetails>
        <LogoutIcon onClick={onLogout}>
          <img src="/assets/logout_icon.png" alt="Logout" />
        </LogoutIcon>
      </UserInfo>
    </SidebarContainer>
  );
};

export default Sidebar; 